var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"multiple":""},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}}),_c('van-button',{on:{"click":_vm.uplod}},[_vm._v("上传")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }